import React from "react";
import Logo1 from "../assests/Logo.png";
import Logo2 from "../assests/Brandifi.png";
import bigLogo from "../assests/bigLogo.png";
import { Link } from 'react-scroll';
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { useState } from "react";
import Welcome from '../assests/Welcome.png';
import Brandifi from '../assests/Brandifibig.png'
import ptag from '../assests/heroptag.png'

function Navbar() {
  const [showMenu, setShowMenu] = useState(false);
  function handleNav() {
    setShowMenu(!showMenu);
  }

  return (
    <div className="bg-gradient-to-br from-[#001002] via-[#000000] to-[#001002] h-screen">
      <div className=" h-screen topp overflow-hidden ">
        <div className="  h-[100px]  text-white flex justify-center">
          <div
            className=" mx-auto px-5 w-[1370px]
         h-full items-center flex justify-between"
          >
            <div className="inline-flex ">
              <div>
                <img className=" w-11" src={Logo1} alt="" />
              </div>
              <img className="p-3 w-40" src={Logo2} alt="" />
            </div>

            <div>
              <ul className="hidden md:flex items-center cursor-pointer">
                <li><Link to="Hero" spy={true} smooth={true}
                  offset={-100}
                  duration={800} >
                  Services
                </Link>
                </li>

                <li><Link to="Special" spy={true} smooth={true}
                  offset={-100}
                  duration={800} >
                  Why Us
                </Link>
                </li>

                <li><Link to="Journey" spy={true} smooth={true}
                  offset={-100}
                  duration={800} >
                  Expertise
                </Link>
                </li>
                <button className="rounded border-2 p-3">Get Started</button>
              </ul>
            </div>

            {/* mobile menu hamburger */}
            <div onClick={handleNav} className="block md:hidden">
              {showMenu ? (
                <AiOutlineClose size={30} />
              ) : (
                <AiOutlineMenu size={30} />
              )}
            </div>

            {/* mobile menu */}
            <div
              className={
                showMenu
                  ? "top-[142px] absolute md:hidden bg-black  w-full left-0  flex justify-center text-center transition-opacity duration-300"
                  : "hidden"
              }
            >
              <ul>
                <li className=" text-xl cursor-pointer">
                <Link to="Hero" spy={true} smooth={true}
                  offset={-100}
                  duration={800} >
                  Services
                </Link>
                </li>

                <li className=" text-xl cursor-pointer">
                <Link to="Special" spy={true} smooth={true}
                  offset={0}
                  duration={800} >
                  Why Us
                </Link>
                </li>

                <li className=" text-xl cursor-pointer">
                <Link to="Journey" spy={true} smooth={true}
                  offset={-100}
                  duration={800} >
                  Expertise
                </Link>
                </li>
                <button className="rounded border-2 p-2 m-6 text-xl">
                  Get Started
                </button>
              </ul>
            </div>
          </div>
        </div>

        <div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1440"
            height="34"
            viewBox="0 0 1440 34"
            fill="none"
          >
            <path
              d="M0 33H175.25H262.875H306.688L350.5 1L701 1H1440"
              stroke="url(#paint0_linear_423_1367)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_423_1367"
                x1="0.000183096"
                y1="0.500297"
                x2="1440"
                y2="0.500285"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#0FBA2C" />
                <stop offset="0.152181" stop-color="#58CF6C" />
                <stop offset="0.503125" stop-color="white" />
                <stop offset="1" stop-color="white" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        {/* hero page */}

        <div className="max-w-[1260px] mx-auto py-5 services">

          <div className=" w-full px-4 py-4 md:py-15  flex flex-col justify-center items-center md:flex md:flex-row md:justify-around overflow-hidden ">

            <div className=" text-white  md:mr-10 md:px-4 md:py-16 m-auto md:mx-0 text-center md:text-left">

              <img className=" h-[30px] md:h-[40px] lg:h-[53px] mt-5" src={Welcome} alt="" srcset="" />
              <img className="mx-auto md:mx-0 h-[30px] md:h-[40px] lg:h-[56px] mt-5 md:mt-8" src={Brandifi} alt="" />
              <img className=" mx-auto md:mx-0 h-[50px] md:h-[50px] lg:h-[64px] mt-5" src={ptag} alt="" />
              <button className="mt-5 py-2 md:py-3 px-8 bg-black">Contact Us</button>
            </div>

            <div className=" max-w-[260px] md:max-w-[400px] lg:max-w-[430px] md:ml-10">
              <img src={bigLogo} alt="" />
            </div>

          </div>

        </div>

      </div>
    </div>
  );
}

export default Navbar;
